import React from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';

import BlueBanner from '../components/shared/BlueBanner';
import IntroTile from '../components/shared/IntroTile';
import SuccessProbabilityBar from '../components/SuccessProbabilityBar';
import CardContainer from './CardContainer';
import { matchPathname } from '../Utils';
import { anonymousUserData } from '../components/shared/Content';
import RasBanner from '../components/shared/RasBanner';
import AdviceFooterImpl from '../components/shared/Footer/AdviceFooterImpl';
import { nextStepsURLs } from '../components/shared/Links';

export default function AnonymousUserContainer({ applicationConfig }) {
    const { age, clientType, confidenceScoreResult, showMeter, upperLimit, lowerLimit } = anonymousUserData;

    React.useEffect(() => {
        let isLoaded = false;
        const { validNS } = JSON.parse(localStorage.getItem('RIC')) || {};

        console.log('validNS', validNS);
        if (!isLoaded && matchPathname(nextStepsURLs).length) {
            if (validNS) {
                console.log('validNS', validNS);
                setTimeout(() => {
                    localStorage.setItem('RIC', JSON.stringify({ validNS: false }));
                }, 3000)
            }
            if (JSON.parse(localStorage.getItem('RIC')) && !validNS) {
                console.log('validNS', validNS);
                localStorage.removeItem('RIC');
                //window.location.replace('/usis/advice/tools/retirement-income-calculator');
            }
            if (!JSON.parse(localStorage.getItem('RIC'))) {
                //window.location.replace('/usis/advice/tools/retirement-income-calculator');
                console.log('thing')
            }
        }

        return () => {
            isLoaded = true;
        };
    }, []);

    return (
        <ThemeProvider theme={createTheme()}>
            <BlueBanner />
            <IntroTile applicationConfig={applicationConfig} />
            <SuccessProbabilityBar
                age={age}
                confidenceScoreResult={confidenceScoreResult}
                showMeter={showMeter}
                upperLimit={upperLimit}
                lowerLimit={lowerLimit}
            />
            <CardContainer
                clientType={clientType}
                confidenceScoreResult={confidenceScoreResult}
            />
            {window.location.pathname.includes('next-steps') && (
                <RasBanner />
            )}
            <AdviceFooterImpl />
        </ThemeProvider>
    );
};
